import React from "react";

export const UploadIcon: React.FC = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9182 15.1268V5.92627L9.75816 8.00288C9.36816 8.37783 8.73816 8.37783 8.34816 8.00288C7.95816 7.62794 7.95816 7.02226 8.34816 6.64731L12.1782 2.96517C12.5682 2.59022 13.1982 2.59022 13.5882 2.96517L17.4382 6.66654C17.8282 7.04149 17.8282 7.64717 17.4382 8.02211C17.0482 8.39705 16.4182 8.39705 16.0282 8.02211L13.9182 5.99357V15.1268C13.9182 15.6556 13.4682 16.0882 12.9182 16.0882C12.3682 16.0882 11.9182 15.6556 11.9182 15.1268Z"
        fill="#000000"
      />
      <path
        d="M20.938 14.4635V17.963H4.95801V14.4635C4.95801 13.9347 4.50801 13.5021 3.95801 13.5021C3.40801 13.5021 2.95801 13.9347 2.95801 14.4635V18.9243C2.95801 19.4531 3.40801 19.8857 3.95801 19.8857H21.938C22.488 19.8857 22.938 19.4531 22.938 18.9243V14.4635C22.938 13.9347 22.488 13.5021 21.938 13.5021C21.388 13.5021 20.938 13.9347 20.938 14.4635Z"
        fill="#000000"
      />
    </svg>
  );
};
